import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { DATE_LOCALE } from './language-to-locales';

interface DeveloperSaleBadgeProps {
  showBorder?: boolean;
  size?: 'tiny' | 'small' | 'medium';
  amount: string;
  endDate?: Date | string;
  languageCode?: string;
}

export function DeveloperSaleBadge({
  showBorder,
  size = 'small',
  amount,
  endDate,
  languageCode = 'en',
}: DeveloperSaleBadgeProps) {
  const { t } = useEssentials();
  if (typeof endDate === 'string') {
    endDate = new Date(endDate);
  }
  return (
    <Box marginTop="2px">
      <Badge
        skin="standard"
        type="outlined"
        dataHook="dev-sale-badge"
        uppercase={false}
        showBorder={showBorder}
        size={size}
        tooltipContent={
          // @ts-expect-error wds types are incompatible
          <Text size="small" weight="thin" skin="light">
            {t('developer.sale.badge.tooltip', {
              amount,
              endDate: endDate
                ? endDate.toLocaleDateString(DATE_LOCALE[languageCode], {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    timeZone: 'UTC',
                  })
                : '',
            })}
          </Text>
        }
      >
        <Box marginTop="0px" color="#116DFF" fontSize="small">
          - {amount}%
        </Box>
      </Badge>
    </Box>
  );
}
